/* ===========================================================================
   A/B-Test "Glatte Preise" — ABConvert
   Experiment: Glatte Preise (#50298) / Folgetest #50227
   Intern adressiert ABConvert das Experiment ueber die ObjectId
   6a6c675b67344a12201e7c5f — nicht ueber die Nummer aus der UI.

   Blendet ",00" in Preisen aus:  99,00€  ->  99 €
   Zwischen Betrag und Waehrungszeichen steht ein geschuetztes Leerzeichen,
   damit "99" und "€" nicht auf zwei Zeilen umbrechen.

   Nur ",00" wird angefasst. Preise mit Cent (",90", ",99") bleiben stehen —
   sie bedeuten, dass der Price Test die Variante nicht erfasst hat, und ein
   Abschneiden wuerde angezeigten und berechneten Preis auseinanderlaufen
   lassen. Versandkosten, Rabattbetraege und Grundpreise bleiben exakt.

   Ausgeliefert ueber layout/theme.liquid (preload + defer) fuer ALLE Besucher.
   Der Gate unten schaltet den Block nur fuer die Testgruppe scharf (Gruppe > 0);
   Kontrollgruppe und Besucher ausserhalb des Tests sehen unveraenderte Preise.
   =========================================================================== */
(function () {
  'use strict';

  // Doppelte Ausfuehrung verhindern (Re-Injection, SPA-Navigation).
  if (window.__glattePreise) return;

  /* --------------------------------------------------------------- Gate ---
     Sicherheitsnetz, falls der Block doch einmal global ausgeliefert wird.
     Keine Experiment-ID im Code: ABConvert adressiert Experimente intern ueber
     eine ObjectId (6a6c675b67344a12201e7c5f), nicht ueber die Nummer aus der
     UI (#50298). Gelesen wird deshalb, welche Price-Tests laufen und in welcher
     Gruppe der Besucher steckt. Gruppe 0 = Kontrolle bleibt unangetastet.
  ------------------------------------------------------------------------ */

  var PRICE_TEST_DICT_KEY = 'abconvert-price-cart-transform-test-dict';
  var GROUP_MAP_KEY = 'abconvert-experiment-to-group-index';
  var GROUP_KEY_PREFIX = 'abconvert.experiment.';
  var GROUP_KEY_SUFFIX = '.group';

  var ASSIGNMENT_TIMEOUT_MS = 5000;
  var POLL_INTERVAL_MS = 50;

  function readRaw(key) {
    try {
      var local = localStorage.getItem(key);
      if (local !== null) return local;
    } catch (e) {
      /* Storage blockiert (Privatmodus) */
    }
    try {
      return sessionStorage.getItem(key);
    } catch (e) {
      return null;
    }
  }

  // Das Dict ist ~270 KB — per Regex lesen statt JSON.parse, Ergebnis cachen.
  var cachedIds = null;
  function getPriceExperimentIds() {
    if (cachedIds) return cachedIds;

    var raw = readRaw(PRICE_TEST_DICT_KEY);
    if (!raw) return null; // Runtime hat das Dict noch nicht geschrieben

    var ids = [];
    var re = /"experimentId"\s*:\s*"([a-f0-9]{24})"/g;
    var m;
    while ((m = re.exec(raw)) !== null) {
      if (ids.indexOf(m[1]) === -1) ids.push(m[1]);
    }

    cachedIds = ids;
    return ids;
  }

  function groupFromMap(experimentId) {
    try {
      var raw = readRaw(GROUP_MAP_KEY);
      if (!raw) return null;

      var value = JSON.parse(raw)[experimentId];
      return typeof value === 'number' ? value : null;
    } catch (e) {
      return null;
    }
  }

  function groupFromKey(experimentId) {
    var raw = readRaw(GROUP_KEY_PREFIX + experimentId + GROUP_KEY_SUFFIX);
    if (raw === null) return null;

    // Wert ist mal ein plain String ("1"), mal JSON ({"groupIndex":1}).
    var direct = Number(raw);
    if (!isNaN(direct)) return direct;

    try {
      var parsed = JSON.parse(raw).groupIndex;
      return typeof parsed === 'number' ? parsed : null;
    } catch (e) {
      return null;
    }
  }

  function resolveGroupIndex(experimentId) {
    var fromMap = groupFromMap(experimentId);
    return fromMap !== null ? fromMap : groupFromKey(experimentId);
  }

  // null = noch nicht entscheidbar, sonst {active, groups}
  function evaluate() {
    var ids = getPriceExperimentIds();
    if (!ids) return null;
    if (ids.length === 0) return { active: false, groups: {} };

    var groups = {};
    var resolved = 0;
    var active = false;

    for (var i = 0; i < ids.length; i++) {
      var groupIndex = resolveGroupIndex(ids[i]);
      groups[ids[i]] = groupIndex;

      if (groupIndex !== null) {
        resolved++;
        if (groupIndex > 0) active = true;
      }
    }

    if (active) return { active: true, groups: groups };
    if (resolved === ids.length) return { active: false, groups: groups };

    return null; // Zuweisung laeuft noch
  }

  // Bei wiederkehrenden Besuchern steht die Zuweisung sofort da, beim ersten
  // Seitenaufruf erst nach abconvert-runtime.js — deshalb pollen.
  function waitForAssignment(callback) {
    var deadline = Date.now() + ASSIGNMENT_TIMEOUT_MS;

    (function poll() {
      var result = evaluate();
      if (result) return callback(result.active, result.groups, 'resolved');
      if (Date.now() > deadline) return callback(false, {}, 'timeout');

      setTimeout(poll, POLL_INTERVAL_MS);
    })();
  }

  /* -------------------------------------------------------- Preis-Patch ---
     Nur Textknoten werden angefasst. Elemente werden nie versteckt oder
     entfernt, Attribute nie geschrieben. Damit bleiben DataLayer, JSON-LD und
     alle data-price-Attribute unberuehrt.
  ------------------------------------------------------------------------ */

  var CONTAINERS = [
    '.price', // jeder Preis im Theme
    '.price-list', // Wrapper, faengt Text zwischen den Spans
    '.totals', // Warenkorb: Summe / Versand / Endsumme
    'free-shipping-bar', // "Noch X € bis zum kostenlosen Versand"
    '.label--highlight', // Ersparnis-Badges
    '.mini-cart__discount-price',
    '.cart__discount-price',
    'cart-drawer',
    '.predictive-search',
    'product-sticky-form'
  ].join(',');

  // 1.234,00 € / 99,00€ / 99,00 EUR — nur glatte Betraege.
  var PRICE_RE = /(\d{1,3}(?:[.\s ]\d{3})*),00\s*(€|EUR)/g;
  var REPLACEMENT = '$1 $2'; // geschuetztes Leerzeichen

  var patchCount = 0;

  function stripCents() {
    var containers = document.querySelectorAll(CONTAINERS);

    for (var i = 0; i < containers.length; i++) {
      var walker = document.createTreeWalker(containers[i], NodeFilter.SHOW_TEXT, null, false);

      for (var node; (node = walker.nextNode()); ) {
        var next = node.nodeValue.replace(PRICE_RE, REPLACEMENT);

        // Loop-Bremse: Zuweisung an nodeValue queued IMMER einen
        // characterData-Record, auch bei identischem Wert. Ohne diesen
        // Vergleich feuert der MutationObserver endlos.
        if (next !== node.nodeValue) {
          node.nodeValue = next;
          patchCount++;
        }
      }
    }
  }

  var queued = false;
  function refresh() {
    if (queued) return;
    queued = true;

    requestAnimationFrame(function () {
      queued = false;
      stripCents();
    });
  }

  function observe() {
    stripCents();

    // Noetig, weil Warenkorb-Drawer, Varianten-Wechsel, Predictive Search und
    // der Summenblock (Section Rendering API) nachtraeglich neu rendern.
    new MutationObserver(refresh).observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }

  function boot() {
    if (document.body) {
      observe();
    } else {
      document.addEventListener('DOMContentLoaded', observe, { once: true });
    }
  }

  /* --------------------------------------------------------------- Start -- */

  waitForAssignment(function (active, groups, reason) {
    // QA: window.__glattePreise in der Konsole pruefen.
    window.__glattePreise = {
      active: active,
      groups: groups,
      reason: reason,
      patched: function () {
        return patchCount;
      }
    };

    if (active) boot();
  });
})();
